<template>
    <v-container class="content-container pb-14">
        <v-row>
            <v-col>

                <!-- Page title -->
                <div class="page-heading mb-14">
                    Informativni izračun obrokov
                </div>

                <InstalmentPlanComponent ref="installmentComponent"
                    v-model:data="InstallmentPlanDataObject"

                ></InstalmentPlanComponent>
                
                <NavigationButtonsComponent :buttons="buttonState" :on-action="handleNavigationButtonAction" :on-navigation="handleNavigationButtonNavigation" />

    
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import { ref, computed, watch, onBeforeMount, provide } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { INavigationButton, NavigationButtonsComponent, InstalmentPlanComponent, INavigationButtonResult, INavigationAPI } from "nlb-buy-go-library";
    import { useInstallmentPlanDataObject } from "@/app/store/app/component/informative-calc-installment-plan-component";
    import { useInformativeCalculationStore } from "@appstore/informative-calculation-store";
    import { EnumFlowType } from "nlb-buy-go-library";
    import { useAppStore } from "@/app/store/app/app-store";

    const { InstallmentPlanDataObject } = useInstallmentPlanDataObject();
    const informativeCalculationStore = useInformativeCalculationStore();
    const appStore = useAppStore();

    const installmentComponent = ref();

    async function navigationAction(buttonId: string) {
            const result = await installmentComponent.value?.navigationAction?.(buttonId);
            return result;
        };

        defineExpose({ navigationAction });

    function resetStore() {
        informativeCalculationStore.reset()
        informativeCalculationStore.InfoState.CalculationData.flowType = EnumFlowType.PORTAL_INFOCALC;
    }

    const route = useRoute();
    const router = useRouter();

    const navigation = computed(() => route.meta.navigation as Record<string, string>);
    const buttonState = ref<INavigationButton[]>([]);

    watch(() => route.meta.buttons, (newButtons) => {
        if (Array.isArray(newButtons)) {
            buttonState.value = JSON.parse(JSON.stringify(newButtons));
        }
    }, { immediate: true });

    const setButtonVisible = (name: string, visible: boolean) => {
        const btn = buttonState.value.find((b: INavigationButton) => b.name === name);
        if (btn) {
            btn.visible = visible;
        }
    };

    const setButtonDisabled = (name: string, visible: boolean) => {
        const btn = buttonState.value.find((b: INavigationButton) => b.name === name);
        if (btn) btn.disabled = visible;
    };

    const navigationButtonsApi: INavigationAPI = {
        setButtonVisible,
        setButtonDisabled,
    };

    provide('navigationButtonsApi', navigationButtonsApi);

    provide("generalStore", {
        state: {
            get countryList() {
                return appStore.CountryList;
            },
            get countryPhoneList() {
                return appStore.CountryPhoneList;
            },
            get postalCodeList() {
                return appStore.PostalCodeList;
            }
        }
    });

    // Handle button clicks
    const handleNavigationButtonAction = async (action: string) => {
        const result: INavigationButtonResult = await installmentComponent.value.navigationAction(action);
        if (result != null && result.name != null && navigation.value[result.name] != null) {
            await router.push({
                name: navigation.value[result.name],
                ...(result.params && { params: result.params })
            });
        }
    };

    // Handle button redirects
    const handleNavigationButtonNavigation = async (navigateTo: string | undefined) => {
        if (navigateTo != undefined) {
            await router.push({
                name: navigation.value[navigateTo]
            });
        }
    };

    onBeforeMount(() => {
        console.log("resetting store.");
        resetStore();
    });
</script>